import { VALAQUENTA_API_URL } from "../..";
import { authorizedAxios, loggingAxios } from "../../../App";

export async function fetchRestaurantReservations({ params }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/restaurant/`,
    {
      params,
    }
  );
}

export function retrieveRestaurantReservation({ reference }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/restaurant/${reference}/`
  );
}
export async function patchRestaurantReservation({ reference, payload }) {
  return await loggingAxios.patch(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/restaurant/${reference}/`,
    payload
  );
}
export async function getRestaurantReservationStats({ params }) {
  return await authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/restaurant/stats/`,
    { params }
  );
}
